import selectedVideoSet from './bi-handlers/selected-video';

export default {
  ...selectedVideoSet,
};
